import { IGameAttendanceView, IGameAttendances } from "@grassrootly/api";

/**
 * Converts IGameAttendanceView to IGameAttendances format for backward compatibility
 */
export const adaptAttendanceViewToAttendances = (attendanceViews: IGameAttendanceView[]): IGameAttendances[] => {
  return attendanceViews.map((view, index) => ({
    id: view.player_attendance_id, // Use the actual attendance record ID for voting
    game_id: view.game_id,
    player_id: view.player_id,
    attended: view.player_attended,
    team: view.player_team,
    rating: view.player_game_rating || 0,
    points_earned: view.player_experience_earned || 0,
    goals_scored: view.player_goals || 0,
    assists_made: view.player_assists || 0,
    points_earned_breakdown: view.player_points_earned_breakdown,
    created_at: view.attendance_created_at,
    position: view.player_position,
    yellow_cards: view.player_yellow_cards || 0,
    red_cards: view.player_red_cards || 0,
    saves: view.player_saves || 0,
    own_goals: view.player_own_goals || 0,
    errors_leading_to_a_goal: view.player_errors_leading_to_a_goal || 0,
    player: {
      id: view.player_id,
      name: view.player_name,
      profile_picture: view.player_profile_pic,
      created_at: "", // This field doesn't exist in the view, using default
      user_id: null, // This field doesn't exist in the view, using default
      email: "", // This field doesn't exist in the view, using default
    },
  }));
};
